import { render, staticRenderFns } from "./payment-successful.vue?vue&type=template&id=a2b1d05c&scoped=true"
import script from "./payment-successful.vue?vue&type=script&lang=js"
export * from "./payment-successful.vue?vue&type=script&lang=js"
import style0 from "./payment-successful.vue?vue&type=style&index=0&id=a2b1d05c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b1d05c",
  null
  
)

export default component.exports